import * as React from 'react';

import PropTypes from 'prop-types';

import styles from './funnel-empty-state.module.css';

export class FunnelEmptyState extends React.Component {
    static propTypes = {
        isError: PropTypes.bool.isRequired,
    };

    render() {
        const emptyText = this.props.isError
            ? "We couldn't load your funnel"
            : 'No leads were found in the funnel';

        return (
            <div className={styles.container}>
                <div className={styles['empty-image-container']}>
                    <img
                        src='/include/images/dashboard/funnel-empty_2x.png'
                        className={styles['empty-image']}
                    />
                </div>
                <div className={styles['empty-text']}>
                    <span>{emptyText}</span>
                </div>
            </div>
        );
    }
}
